
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/signup",
      function () {
        return require("private-next-pages/user/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/signup"])
      });
    }
  